import { waitFor, screen } from "@testing-library/react";
export const waitForIconsToLoad = async ()=>{
    try {
        await waitFor(()=>screen.getAllByTestId((id)=>id.startsWith(`SvgIcon`)));
    } catch  {
        console.warn("Icons not loaded... continuing");
    }
};
